import { render } from "./LineChartDemo.vue?vue&type=template&id=08d1990c&scoped=true"
import script from "./LineChartDemo.vue?vue&type=script&lang=ts"
export * from "./LineChartDemo.vue?vue&type=script&lang=ts"

import "./LineChartDemo.vue?vue&type=style&index=0&id=08d1990c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08d1990c"

export default script